import { memo, useEffect } from 'react';

export const InjectRovoServiceAgentWidgetScript = memo(function RovoServiceAgentWidget({
    siteId,
    widgetId,
}: {
    siteId: string;
    widgetId: string;
}) {
    useEffect(() => {
        const site = window.location.hostname;

        const src = new URL(`https://${site}/rovo/widget/script.js`);
        src.searchParams.set('siteId', siteId);
        src.searchParams.set('site', site);
        src.searchParams.set('widgetId', widgetId);

        const script = document.createElement('script');
        script.async = true;
        script.src = src.toString();
        script.setAttribute('data-testid', 'rovo-service-agent-widget-script');

        const body = document.querySelector('body');
        body?.appendChild(script);

        return () => {
            body?.removeChild(script);
        };
    }, [widgetId, siteId]);

    return null;
});
